import React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';

import ocpfLogo from '../../../../images//ocpfsmallicon.png';

const Footer = (): JSX.Element => {

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Stack alignItems={'center'}>
          <Box
            display={'flex'}
            component="a"
            href="/"
            title="OCPF"
            width={80}
            marginBottom={2}
          >
            <Box
              component={'img'}
              alt="OCPF Logo"
              title="OCPF"
              aria-label='OCPF Logo'
              loading="lazy"
              src={ocpfLogo}
              height={1}
              width={1}
            />
          </Box>
          <Typography
          align={'center'}
          variant={'subtitle2'}
          component={'p'}
          color="text.secondary"
          gutterBottom
        >
          &copy; {new Date().getFullYear()} Massachusetts Office of Campaign and Political Finance
        </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Footer;
